import type { LessonPrice } from './types';

export function formatLessonAmount(price: LessonPrice, locale: string): string {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: price.currency,
    maximumFractionDigits: 0,
  }).format(price.amount);
}
